import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Avatar from '@material-ui/core/Avatar';
import CardHeader from '@material-ui/core/CardHeader';
import ReactLoading from 'react-loading';

const styles = theme => ({
    messageText: {
        background: '#fff',
        borderRadius: 3,
        borderBottomLeftRadius: 23,
        borderBottomRightRadius: 23,
        padding: '12px 16px',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
        marginLeft: 6,
        marginRight: 6,
        marginBottom: 3,
    },
    messageTextLeft: {
        borderTopRightRadius: 23,
        borderBottomLeftRadius: 3,
        float: 'left',
    },
    messageTextRight: {
        borderTopLeftRadius: 23,
        borderBottomRightRadius: 3,
        float: 'right',
        background: '#2196f3',
        color: '#fff',
    },
    messageTextFirst: {
        borderTopRightRadius: 23,
        borderTopLeftRadius: 23,
    },
    loadingIcon: {},
    loadingText: {
        color: 'rgba(0, 0, 0, 0.26)',
        fontStyle: 'italic',
    },
    loadingDots: {
        display: 'inline-block',
        minWidth: 12
    },
    loadingBubblesWrapper: {
        margin: '-13.5px -4px',
    }
});

class MessageContent extends PureComponent {
    state = {showLoading: false, loadingTextDotCount: 3};

    componentWillMount() {
        if (this.props.showLoading) {
            this.setState({
                showLoading: this.props.showLoading,
            })
            const dotAnimation = setInterval(() => {
                this.setState({loadingTextDotCount: this.state.loadingTextDotCount > 2 ? 0 : this.state.loadingTextDotCount + 1})
            }, 500)
            setTimeout(() => {
                this.setState({showLoading: false})
                clearInterval(dotAnimation)
            }, 2000)
        }
    }

    render() {
        const {classes, sender, messages, bot} = this.props;
        const {showLoading, loadingTextDotCount} = this.state;

        const messageTextClass = sender === 'bot' ? classes.messageTextLeft : classes.messageTextRight

        return (
            <div className={classes.messageContainer}>
                {messages.map((message, key) => {
                    return (
                        <div
                            className={classes.messageText + ' ' + messageTextClass + ' ' + (key === 0 ? classes.messageTextFirst : null)}>
                            {false && showLoading && <span className={classes.loadingText}>
                                {bot.nameShort + ' kirjoittaa viestiä'}
                                <div className={classes.loadingDots}>{'.'.repeat(loadingTextDotCount)}</div>
                                </span>
                            }
                            {showLoading && <div className={classes.loadingBubblesWrapper}><ReactLoading type={'bubbles'} color={'grey'} height={50} width={50} /></div>}
                            {!showLoading && message}
                        </div>
                    )
                })}
            </div>
        );
    }
}

MessageContent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MessageContent);
